import React, { useState, useRef } from "react";
import {
  Grid,
  Paper,
  Typography,
  Divider,
  Button,
  Collapse,
  Box,
  Badge,
  Modal,
  Fade,
  IconButton,
  Autocomplete,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TextField,
  Popper,
  CircularProgress,
  Card,
  CardMedia,
  CardContent,
  Chip,
} from "@mui/material";
import {
  CameraAlt,
  CameraFront,
  CameraRear,
  Close,
  DirectionsCarFilledOutlined,
  Download,
  Edit,
  HelpOutline,
  KeyboardArrowDown,
  KeyboardArrowUp,
  PersonAdd,
  Photo,
  SwapHorizOutlined,
} from "@mui/icons-material";
import { Local, Transferencia, VehicleData } from "../../../types/vehicleData";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { formatDate, formatDateTime } from "../../../services/formatDate";
import { useNavigate } from "react-router-dom";
import CanvasDraw from "react-canvas-draw";
import {
  getImagesVehicle,
  transferLocalVehicle,
  uploadCapturedImages,
  uploadSignedTransfer,
} from "../../../api/vehicleApi";
import { getEmpresaLocais } from "../../../api/dashboardApi";
import Webcam from "react-webcam";
import { formatDocument } from "../../../services/formatDocument";
import { generatePDFGroup } from "../../../api/checklistApi";
import CloseIcon from "@mui/icons-material/Close";
import { AxiosError } from "axios";
import { EntregaCameraModal } from "./components/EntregaCameraModal";
import { useEnviarFotosEntrega } from "./hooks/useEnviarFotosEntrega";

const VehicleCard: React.FC<{
  vehicle: VehicleData;
  expandedPaperId: number | null;
  handlePaperClick: (id: number) => void;
  handleEditButtonClick: (vehicleId: number) => void;
  handleAddClientButtonClick: (vehicleId: number) => void;
  handleViewClientButtonClick: (vehicleId: number, clientId: number) => void;
  handleChecklistButtonClick: (
    checklistId: string,
    vehicleId: string,
    idChecklistRespondido?: string,
  ) => void;
  onVehicleTransfer: () => void;
}> = ({
  vehicle,
  expandedPaperId,
  handlePaperClick,
  handleEditButtonClick,
  handleAddClientButtonClick,
  handleViewClientButtonClick,
  handleChecklistButtonClick,
  onVehicleTransfer,
}) => {
  const token = localStorage.getItem("token");
  const navigate = useNavigate();
  const webcamRef = useRef<Webcam>(null);
  const [loading, setLoading] = useState(false);
  const [companies, setCompanies] = useState<any[]>([]);
  const [historico, setHistorico] = useState<any[]>([]);
  const [selectedCompany, setSelectedCompany] = useState<any>(null);
  const [filteredLocations, setFilteredLocations] = useState<any[]>([]);
  const [openModal, setOpenModal] = useState(false);
  const [openModalHistoricoFotos, setOpenModalHistoricoFotos] = useState(false);
  const [transferModal, setTransferModal] = useState(false);
  const [photos, setPhotos] = useState<any>(null);
  const [descricao, setDescricao] = useState("");
  const [nomeTransferencia, setNomeTransferencia] = useState("");
  const [documentoTransferencia, setDocumentoTransferencia] = useState("");
  const [isSignOpen, setIsSignOpen] = useState(false);
  const [signed, setSigned] = useState<string>("");
  const canvasRef = useRef<any>(null);
  const [openRow, setOpenRow] = useState<number | null>(null);
  const [isFrontFacing, setIsFrontFacing] = useState(true);
  const [isCameraOpen, setIsCameraOpen] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState<Local | null>(null);
  const [capturedImages, setCapturedImages] = useState<string[]>([]);
  const [historicoFotos, setHistoricoFotos] = useState<string[]>([]);
  const [pdfModalOpen, setPdfModalOpen] = useState(false);
  const [loadingPdf, setLoadingPdf] = useState(false);
  const [pdfUrl, setPdfUrl] = useState("");
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const [isFullscreenOpen, setIsFullscreenOpen] = useState(false);
  const [cameraEntregaOpen, setCameraEntregaOpen] = useState(false);
  const { enviarFotosEntrega, loading: loadingEnvioFotos } =
    useEnviarFotosEntrega();

  const userDataString = localStorage.getItem("userData");
  const userData = userDataString ? JSON.parse(userDataString) : null;

  const shouldShowTransferButton =
    userData && userData.tipo_transferencia === "Tipo_Completo";

  const CustomPopper = (props: any) => {
    return <Popper {...props} placement="top" />;
  };

  const handleOpenFullscreen = (url: string) => {
    setSelectedImage(url);
    setIsFullscreenOpen(true);
  };

  const handleCloseFullscreen = () => {
    setSelectedImage(null);
    setIsFullscreenOpen(false);
  };

  const handleSalvarFotosEntrega = async (images: string[]) => {
    if (!token) {
      toast.error("Token de autenticação não encontrado");
      return;
    }

    const sucesso = await enviarFotosEntrega(token, vehicle.id, images);
    if (sucesso && openModal) {
      const photosData = await getImagesVehicle(token, vehicle.id.toString());
      setPhotos(photosData);
    }
  };

  const handleChecklistClick = (acao: any) => {
    if (acao.cliente_obrigatorio_acoes === true && !vehicle.id_cliente) {
      toast.error("Obrigatório vincular um cliente ao veículo");
      return;
    }
    handleChecklistButtonClick(
      acao.id_checklist.toString(),
      vehicle.id.toString(),
      acao.id_checklist_respondido,
    );
  };

  const handleRowClick = (index: number) => {
    setOpenRow(openRow === index ? null : index);
  };

  const handleOpenModal = async () => {
    setOpenModal(true);
    try {
      const photosData = await getImagesVehicle(token!, vehicle.id.toString());
      setPhotos(photosData);
    } catch (error) {
      console.error("Erro ao carregar fotos:", error);
      toast.error("Erro ao carregar fotos.");
    }
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setPhotos(null);
  };

  const handleOpenModalTransfer = async () => {
    setTransferModal(true);
    try {
      const companiesData = await getEmpresaLocais(token!, vehicle.id);
      setCompanies(companiesData.empresas);
      setHistorico(companiesData.historico);
    } catch (error) {
      toast.error("Erro ao buscar empresas.");
      console.error("Erro ao buscar empresas:", error);
    }
  };

  const handleCloseModalTransfer = () => {
    setTransferModal(false);
    setCompanies([]);
    setSelectedCompany(null);
    setDescricao("");
    setNomeTransferencia("");
    setDocumentoTransferencia("");
    setCapturedImages([]);
    setSigned("");
  };

  const handleOpenModaHistoricoFotos = (fotos: string[]) => {
    setHistoricoFotos(fotos);
    setOpenModalHistoricoFotos(true);
  };

  const handleDownloadImage = async (url: string) => {
    window.open(`${url}`, "_blank");
  };

  const videoConstraints = {
    facingMode: isFrontFacing ? "user" : "environment",
  };

  const handleCompanyChange = (event: any, newValue: any) => {
    setSelectedCompany(newValue);
    if (newValue) {
      setFilteredLocations(newValue.locais);
    } else {
      setFilteredLocations([]);
    }
    setSelectedLocation(null);
  };

  const handleRemoveCapturedImage = (index: number) => {
    setCapturedImages((prevImages) => prevImages.filter((_, i) => i !== index));
  };

  const handleOpenCamera = () => {
    setIsCameraOpen(true);
  };

  const toggleCameraFacing = () => {
    setIsFrontFacing(!isFrontFacing);
  };

  const handleCloseCamera = () => {
    setIsCameraOpen(false);
  };

  const handleCloseModalHistoricoFotos = () => {
    setOpenModalHistoricoFotos(false);
  };

  const capture = () => {
    if (webcamRef.current) {
      const imageSrc = webcamRef.current.getScreenshot();
      if (imageSrc) {
        setCapturedImages((prevImages) => [...prevImages, imageSrc]);
      }
      setIsCameraOpen(false);
    }
  };

  const handleDocumentoChange = (event: any) => {
    const formattedDocument = formatDocument(event.target.value);
    setDocumentoTransferencia(formattedDocument);
  };

  const handleTransferVehicle = async () => {
    if (selectedCompany && selectedLocation) {
      try {
        setLoading(true);

        const response = await transferLocalVehicle(
          vehicle.id,
          selectedCompany.id,
          selectedLocation.id,
          descricao,
          token!,
        );

        const idTransferencia = response.id;

        if (capturedImages.length > 0) {
          const uploadPromises = capturedImages.map(async (image) => {
            try {
              await uploadCapturedImages(image, idTransferencia, token!);
            } catch (error) {}
          });

          if (signed) {
            await uploadSignedTransfer(
              signed,
              idTransferencia,
              nomeTransferencia,
              1,
              documentoTransferencia,
              token!,
            );
          }

          const allUploadPromises = [...uploadPromises];
          await Promise.all(allUploadPromises);
        }

        toast.success("Veículo transferido com sucesso!");
        handleCloseModalTransfer();
        onVehicleTransfer();
      } catch (error) {
        if (error instanceof AxiosError && error.response) {
          const errorMessage = error.response.data.error;
          toast.error(errorMessage);
        } else {
          toast.error("Erro ao transferir veículo.");
        }
      } finally {
        setLoading(false);
      }
    } else {
      toast.error("Selecione uma empresa e um local.");
    }
  };

  const handleClearSignature = () => {
    setSigned("");
    setIsSignOpen(false);
  };

  const handleOpenSign = () => {
    if (signed) {
      setIsSignOpen(true);
    } else {
      setIsSignOpen(true);
    }
  };

  const handleCloseSign = () => {
    setIsSignOpen(false);
    if (!signed) {
      handleClearSignature();
    }
  };

  const handleExport = () => {
    const base64 = canvasRef.current.canvasContainer.childNodes[1].toDataURL();

    setSigned(base64);
    setIsSignOpen(false);
    toast.success("Assinatura salva com sucesso!");
  };

  const isIOS = () =>
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

  const handleGeneratePdf = async (id_veiculo: number) => {
    try {
      const allChecklistsResponded = vehicle.acoes.every(
        (acao) => acao.checklist_respondido,
      );

      if (!allChecklistsResponded) {
        toast.error(
          "É necessário preencher todos os checklists para gerar o PDF!",
        );
        return;
      }

      if (!token) {
        throw new Error("Token de autenticação não encontrado");
      }

      setLoadingPdf(true);

      if (isIOS()) {
        const result = await generatePDFGroup(token, id_veiculo);
        const url: string = result.pdf;
        setPdfUrl(url);
        window.open(url, "_blank", "noopener,noreferrer");
        return;
      }

      setPdfModalOpen(true);
      const pdfUrl = await generatePDFGroup(token, id_veiculo);
      setPdfUrl(pdfUrl.pdf);
    } catch (error) {
      console.error("Erro ao gerar PDF:", error);
      toast.error("Erro ao gerar PDF");
      setPdfModalOpen(false);
    } finally {
      setLoadingPdf(false);
    }
  };

  const checklistRespondidoCount =
    vehicle.acoes.length > 0
      ? vehicle.acoes.filter((acao: any) => acao.checklist_respondido).length
      : 0;

  return (
    <Grid item xs={12}>
      <Paper
        elevation={4}
        sx={{
          p: 1,
          display: "flex",
          flexDirection: "column",
          height: 80,
          borderRadius: 3,
          cursor: "pointer",
          marginBottom: 1,
          backgroundColor:
            expandedPaperId === vehicle.id ? "#FBFBFB" : "#ffffff",
          position: "relative",
          zIndex: 2,
        }}
        onClick={() => handlePaperClick(vehicle.id)}
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Badge
            badgeContent={checklistRespondidoCount}
            overlap="circular"
            sx={{
              "& .MuiBadge-badge": {
                color: "white",
                backgroundColor:
                  vehicle.acoes.length > 0
                    ? vehicle.acoes.some((acao) => acao.atrasado === true)
                      ? "red"
                      : "#1976d2"
                    : "red",
                marginLeft: -0.5,
              },
            }}
            anchorOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
          >
            <DirectionsCarFilledOutlined
              sx={{
                fontSize: { xs: 70, sm: 60, md: 80 },
                color:
                  vehicle.acoes.length > 0
                    ? vehicle.acoes.some((acao) => acao.atrasado === true)
                      ? "red"
                      : "#1976d2"
                    : "red",
              }}
            />
          </Badge>
          <Divider
            orientation="vertical"
            variant="middle"
            flexItem
            sx={{ border: 1, ml: 1 }}
          />
          <Grid container spacing={1} wrap="nowrap" ml={0.01}>
            <Grid item xs={12} sm={12} md={12}>
              <Typography sx={{ typography: { sm: "h5", xs: "caption" } }}>
                <strong>{vehicle.chassi_veiculo ? "V.I.N:" : "Placa:"}</strong>
                {vehicle.chassi_veiculo ?? vehicle.placa_veiculo}
              </Typography>

              <Typography sx={{ typography: { sm: "h5", xs: "caption" } }}>
                <strong>Modelo:</strong> {vehicle.descricao_modelo}
              </Typography>
              <Typography
                sx={{
                  typography: { sm: "body2", xs: "caption" },
                  fontSize: { xs: 9, sm: 13 },
                }}
              >
                <strong>Empresa:</strong> {vehicle.empresa_nome}
              </Typography>
            </Grid>
          </Grid>
          {shouldShowTransferButton && (
            <Button
              variant="contained"
              sx={{
                bgcolor: "#3D62F5",
                ":hover": { bgcolor: "#5c5c5c" },
                mb: 0,
                mr: 0.8,
                height: "100%",
                width: 4,
                minWidth: { xs: 32, sm: 45 },
              }}
              onClick={handleOpenModalTransfer}
            >
              <SwapHorizOutlined sx={{ fontSize: 30 }} />
            </Button>
          )}

          <Box
            sx={{
              flexDirection: "column",
            }}
          >
            <Box sx={{ display: "flex", gap: 1, mb: 1 }}>
              <Button
                variant="contained"
                sx={{
                  bgcolor: "#303030",
                  ":hover": { bgcolor: "#5c5c5c" },
                  minWidth: { xs: 20, sm: 60 },
                }}
                onClick={() => handleEditButtonClick(vehicle.id)}
              >
                <Edit />
              </Button>
              <Button
                variant="contained"
                sx={{
                  bgcolor: "#f57c00",
                  ":hover": { bgcolor: "#e65100" },
                  minWidth: { xs: 20, sm: 60 },
                }}
                disabled={loadingEnvioFotos}
                onClick={() => setCameraEntregaOpen(true)}
              >
                <CameraAlt />
              </Button>
            </Box>

            <Button
              variant="contained"
              sx={{
                bgcolor: vehicle.id_cliente ? "#4caf50" : "#f44336",
                ":hover": {
                  bgcolor: vehicle.id_cliente ? "#388e3c" : "#d32f2f",
                },
                minWidth: { xs: 20, sm: 60 },
              }}
              onClick={() => {
                if (vehicle.id_cliente) {
                  handleViewClientButtonClick(vehicle.id, vehicle.id_cliente);
                } else {
                  handleAddClientButtonClick(vehicle.id);
                }
              }}
            >
              <PersonAdd />
            </Button>
          </Box>
        </Box>
      </Paper>
      <Collapse
        in={expandedPaperId === vehicle.id}
        sx={{ borderRadius: 3, marginTop: -2 }}
      >
        <Paper
          elevation={4}
          sx={{
            p: 2,
            display: "flex",
            flexDirection: "column",
            borderBottomLeftRadius: 9,
            borderBottomRightRadius: 9,
            marginTop: -2,
            zIndex: 1,
            transition: "height 0.2s ease-in-out",
            height: "auto",
            overflow: "hidden",
            backgroundColor: "#E7E7E7",
          }}
        >
          <Box sx={{ mb: 2 }}>
            <Grid container alignItems="center">
              <Grid item xs={12} sm="auto">
                <Typography variant="h5" mt={2}>
                  Mais Detalhes
                </Typography>
              </Grid>

              <Grid
                item
                xs={12}
                sm
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  mt: { xs: 1, sm: 0 },
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    gap: 1,
                    flexWrap: "wrap",
                    justifyContent: { xs: "flex-start", sm: "center" },
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Box
                      sx={{
                        width: 16,
                        height: 16,
                        backgroundColor: "#4CAF50",
                        borderRadius: "50%",
                        mr: 1,
                      }}
                    />
                    <Typography variant="caption">Realizado</Typography>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Box
                      sx={{
                        width: 16,
                        height: 16,
                        backgroundColor: "#d6a204",
                        borderRadius: "50%",
                        mr: 1,
                      }}
                    />
                    <Typography variant="caption">Validação</Typography>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Box
                      sx={{
                        width: 16,
                        height: 16,
                        backgroundColor: "#F44336",
                        borderRadius: "50%",
                        mr: 1,
                      }}
                    />
                    <Typography variant="caption">Não realizado</Typography>
                  </Box>
                </Box>
              </Grid>

              <Grid item xs={12} sm="auto">
                <Box
                  sx={{
                    display: "flex",
                    gap: 1,
                    mt: { xs: 1, sm: 2 },
                    justifyContent: { xs: "flex-start", sm: "flex-end" },
                  }}
                >
                  {vehicle.acoes.some((acao) => acao.agrupar_checklist) &&
                    vehicle.tem_checklist_agrupado && (
                      <Button
                        variant="contained"
                        sx={{
                          height: { xs: 30, sm: 40 },
                          backgroundColor: "#0d6efd",
                          borderRadius: 2,
                          ":hover": {
                            bgcolor: "#1565c0",
                          },
                        }}
                        onClick={() => handleGeneratePdf(vehicle.id)}
                        disabled={loadingPdf}
                      >
                        {loadingPdf ? "Gerando..." : "Gerar PDF"}
                      </Button>
                    )}

                  <Button
                    variant="contained"
                    sx={{
                      height: { xs: 30, sm: 40 },
                      backgroundColor: "#303030",
                      borderRadius: 2,
                      ":hover": {
                        bgcolor: "#5c5c5c",
                      },
                    }}
                    onClick={handleOpenModal}
                  >
                    Ver Fotos
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Box>
          <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={pdfModalOpen}
            closeAfterTransition
            onClose={() => setPdfModalOpen(false)}
          >
            <Box>
              <Fade in={pdfModalOpen}>
                <Box
                  sx={{
                    backgroundColor: "#fff",
                    borderRadius: 2,
                    boxShadow: 24,
                    p: 4,
                    maxWidth: "90vw",
                    margin: 3,
                    height: "auto",
                    marginTop: "20vh",
                    textAlign: "center",
                  }}
                >
                  <Grid container spacing={2} p={2} mt={-6}>
                    <Grid item xs={12}>
                      {loadingPdf && (
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            mt: 2,
                          }}
                        >
                          <Typography variant="h6">
                            Aguarde seu PDF está sendo gerado!
                          </Typography>
                        </Box>
                      )}
                      {loadingPdf && (
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            mt: 3,
                          }}
                        >
                          <CircularProgress sx={{ color: "black" }} />
                        </Box>
                      )}
                    </Grid>
                    {pdfUrl && (
                      <>
                        <Button
                          onClick={() => {
                            setPdfModalOpen(false);
                            setPdfUrl("");
                          }}
                          sx={{
                            backgroundColor: "red",
                            color: "white",
                            ":hover": {
                              bgcolor: "#5c5c5c",
                            },
                          }}
                        >
                          <Typography
                            sx={{
                              typography: {
                                sm: "h6",
                                xs: "caption",
                                lg: "h6",
                                md: "h6",
                              },
                            }}
                          >
                            Fechar
                          </Typography>
                        </Button>
                        <Grid
                          item
                          xs={12}
                          sx={{ height: { xs: 250, sm: 350, lg: 500 } }}
                        >
                          <iframe
                            src={`${process.env.REACT_APP_API_DOMAIN}/storage/${pdfUrl}`}
                            title="PDF"
                            width="100%"
                            height="100%"
                          />
                          <Typography
                            sx={{
                              typography: {
                                sm: "h6",
                                xs: "caption",
                                lg: "h6",
                                md: "h6",
                              },
                            }}
                          >
                            PDF Gerado com sucesso!
                          </Typography>
                        </Grid>
                      </>
                    )}
                  </Grid>
                </Box>
              </Fade>
            </Box>
          </Modal>
          <Grid container spacing={2} mt={0.5}>
            <Grid item xs={12} sm={6} md={6}>
              <Typography sx={{ display: "inline", marginRight: 1 }}>
                Cor:
              </Typography>
              <Typography
                variant="body1"
                sx={{ display: "inline", fontWeight: "bold" }}
              >
                {vehicle.descricao_cor}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <Typography sx={{ display: "inline", marginRight: 1 }}>
                KM Inicial:
              </Typography>
              <Typography
                variant="body1"
                sx={{ display: "inline", fontWeight: "bold" }}
              >
                {vehicle.km_veiculo}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <Typography sx={{ display: "inline", marginRight: 1 }}>
                Código Rádio:
              </Typography>
              <Typography
                variant="body1"
                sx={{ display: "inline", fontWeight: "bold" }}
              >
                {vehicle.codigo_radio_veiculo}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <Typography sx={{ display: "inline", marginRight: 1 }}>
                Ano Veículo:
              </Typography>
              <Typography
                variant="body1"
                sx={{ display: "inline", fontWeight: "bold" }}
              >
                {vehicle.descricao_ano_modelo}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <Typography sx={{ display: "inline", marginRight: 1 }}>
                Data de Armazenagem:
              </Typography>
              <Typography
                variant="body1"
                sx={{ display: "inline", fontWeight: "bold" }}
              >
                {formatDate(vehicle.data_armazenagem_veiculo)}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <Typography sx={{ display: "inline", marginRight: 1 }}>
                Local Armazenagem:
              </Typography>
              <Typography
                variant="body1"
                sx={{ display: "inline", fontWeight: "bold" }}
              >
                {vehicle.descricao_local}
              </Typography>
            </Grid>
          </Grid>

          <Grid container mt={3} spacing={2} justifyContent="center">
            {vehicle.acoes.map((acao) => (
              <Grid item xs={6} sm={6} md={6} key={acao.id}>
                {acao.data_criacao ? (
                  <Typography
                    fontWeight="bold"
                    textAlign={"center"}
                    sx={{ fontSize: { xs: 12, sm: 12, md: 17, lg: 18 } }}
                  >
                    {formatDateTime(acao.data_criacao)}
                  </Typography>
                ) : (
                  <Typography
                    fontWeight="bold"
                    textAlign={"center"}
                    sx={{ fontSize: { xs: 12, sm: 12, md: 17, lg: 18 } }}
                  >
                    Não Preenchido
                  </Typography>
                )}
                <Button
                  variant="contained"
                  fullWidth
                  sx={{
                    height: { xs: 60, sm: 50, md: 50 },
                    borderRadius: 2,
                    display: "flex",
                    ml: -0.5,
                    alignItems: "center",
                    justifyContent: "center",
                    ":hover": {
                      ...(acao.validacao
                        ? { bgcolor: "#F57C00" }
                        : acao.periodico_acao && acao.atrasado
                          ? { bgcolor: "#E65100" }
                          : acao.periodico_acao && acao.checklist_respondido
                            ? { bgcolor: "#3d8f40" }
                            : acao.periodico_acao
                              ? { bgcolor: "#d32f2f" }
                              : { bgcolor: "#5c5c5c" }),
                    },
                    ...(acao.validacao
                      ? { bgcolor: "#FFA726" }
                      : acao.periodico_acao && acao.atrasado
                        ? { bgcolor: "#FB8C00" }
                        : acao.periodico_acao && acao.checklist_respondido
                          ? { bgcolor: "#4CAF50" }
                          : acao.periodico_acao
                            ? { bgcolor: "#F44336" }
                            : acao.checklist_respondido
                              ? { bgcolor: "#4CAF50" }
                              : { bgcolor: "#F44336" }),
                  }}
                  disabled={loading}
                  onClick={() => {
                    if (acao.checklist_respondido && !acao.periodico_acao) {
                      navigate(
                        `/VisualizarChecklist/${acao.id_checklist_respondido}`,
                      );
                    } else {
                      handleChecklistClick(acao);
                    }
                  }}
                >
                  <Typography variant="caption" fontWeight={"bold"}>
                    {acao.checklist}
                  </Typography>
                </Button>
              </Grid>
            ))}
          </Grid>
        </Paper>
      </Collapse>
      <Modal
        open={transferModal}
        closeAfterTransition
        disableEscapeKeyDown
        disableEnforceFocus
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={transferModal}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "80%",
              bgcolor: "background.paper",
              boxShadow: 24,
              p: 4,
              borderRadius: 2,
              maxHeight: "80vh",
              overflowY: "auto",
            }}
          >
            <IconButton
              aria-label="close"
              onClick={handleCloseModalTransfer}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>

            <Typography variant="h5" component="h4">
              Transferência de Veículo
            </Typography>
            <Typography variant="body1" mt={1}>
              <strong>Chassi:</strong> {vehicle.chassi_veiculo}
            </Typography>
            <Typography variant="body1">
              <strong>Modelo:</strong> {vehicle.descricao_modelo}
            </Typography>
            {vehicle.nome_cliente && (
              <Typography variant="body1">
                <strong>Cliente:</strong> {vehicle.nome_cliente}
              </Typography>
            )}

            <Divider sx={{ marginTop: 1 }} />
            {!vehicle.entrega_veiculo && (
              <Box>
                <Autocomplete
                  options={companies}
                  getOptionLabel={(option) => option.nome_empresa}
                  value={selectedCompany}
                  onChange={handleCompanyChange}
                  noOptionsText="Nenhuma empresa encontrada!"
                  PopperComponent={CustomPopper}
                  componentsProps={{
                    popper: {
                      style: { zIndex: 1301 },
                    },
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Selecione a Empresa de Destino"
                      variant="outlined"
                      margin="normal"
                      fullWidth
                    />
                  )}
                />

                {selectedCompany && (
                  <>
                    <Autocomplete
                      options={filteredLocations}
                      getOptionLabel={(option) => option.descricao_local}
                      value={selectedLocation}
                      onChange={(event, newValue) =>
                        setSelectedLocation(newValue)
                      }
                      noOptionsText={"Nenhum local de estoque cadastrado!"}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Selecione o Local de Armazenagem"
                          variant="outlined"
                          margin="normal"
                          fullWidth
                          disabled={!selectedCompany}
                        />
                      )}
                    />
                    <TextField
                      label="Descrição"
                      variant="outlined"
                      multiline
                      rows={2}
                      fullWidth
                      value={descricao}
                      onChange={(event) => setDescricao(event.target.value)}
                      sx={{ mt: 2 }}
                    />
                    <TextField
                      label="Informe seu Nome e Empresa"
                      variant="outlined"
                      required
                      fullWidth
                      value={nomeTransferencia}
                      onChange={(event) =>
                        setNomeTransferencia(event.target.value)
                      }
                      sx={{ mt: 2 }}
                    />
                    <TextField
                      label="Documento"
                      variant="outlined"
                      required
                      fullWidth
                      value={documentoTransferencia}
                      onChange={handleDocumentoChange}
                      sx={{ mt: 2 }}
                    />
                    <Box
                      sx={{
                        mt: 2,
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                      }}
                    >
                      <Button
                        variant="contained"
                        component="label"
                        color="primary"
                        sx={{ color: "white", mr: 1 }}
                        onClick={handleOpenCamera}
                      >
                        <CameraAlt />
                      </Button>
                      <Button
                        variant="contained"
                        sx={{
                          color: "white",
                          backgroundColor: signed ? "green" : "primary",
                        }}
                        onClick={handleOpenSign}
                      >
                        {signed
                          ? "Transferência Assinada"
                          : "Assinar Transferência"}
                      </Button>
                    </Box>
                    {capturedImages.length > 0 && (
                      <Grid container spacing={2} mt={1}>
                        {capturedImages.map((image, index) => (
                          <Grid item xs={12} sm={6} md={4} key={index}>
                            <Box
                              sx={{
                                position: "relative",
                                width: "100%",
                                paddingBottom: "56.25%",
                                borderRadius: "8px",
                                overflow: "hidden",
                              }}
                            >
                              <IconButton
                                sx={{
                                  position: "absolute",
                                  top: 8,
                                  right: 8,
                                  color: "white",
                                  backgroundColor: "rgba(0,0,0,0.6)",
                                  ":hover": {
                                    backgroundColor: "rgba(0,0,0,0.8)",
                                  },
                                  zIndex: 1,
                                }}
                                onClick={() => handleRemoveCapturedImage(index)}
                              >
                                <Close />
                              </IconButton>
                              <img
                                src={image}
                                alt={`Captured ${index}`}
                                style={{
                                  position: "absolute",
                                  top: 0,
                                  left: 0,
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "cover",
                                  borderRadius: "8px",
                                }}
                              />
                            </Box>
                          </Grid>
                        ))}
                      </Grid>
                    )}
                  </>
                )}
                <Modal open={isSignOpen}>
                  <Box
                    sx={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      bgcolor: "background.paper",
                      border: "2px solid #000",
                      boxShadow: 24,
                      p: 4,
                      width: "80%",
                      maxWidth: 800,
                      height: "80%",
                      maxHeight: 350,
                    }}
                  >
                    <IconButton
                      onClick={handleCloseSign}
                      sx={{
                        position: "absolute",
                        top: 10,
                        right: 10,
                        backgroundColor: "red",
                        color: "white",
                        ":hover": {
                          bgcolor: "#5c5c5c",
                        },
                      }}
                    >
                      <Close />
                    </IconButton>
                    <Typography
                      variant="h6"
                      color="black"
                      height={50}
                      sx={{
                        paddingTop: "13px",
                      }}
                    >
                      Assinatura do Responsável
                    </Typography>

                    {signed ? (
                      <>
                        <img
                          src={signed}
                          alt="Assinatura"
                          style={{
                            maxWidth: "100%",
                            height: "auto",
                            marginBottom: 45,
                          }}
                        />
                        <Button
                          variant="contained"
                          onClick={handleClearSignature}
                          sx={{
                            mt: 7,
                            display: "block",
                            margin: "0 auto",
                            backgroundColor: "#303030",
                            ":hover": {
                              bgcolor: "#5c5c5c",
                            },
                          }}
                        >
                          Apagar Assinatura
                        </Button>
                      </>
                    ) : (
                      <>
                        <Box
                          mb={5}
                          display="flex"
                          alignItems="center"
                          borderBottom={2}
                        >
                          <CanvasDraw
                            brushColor={"black"}
                            brushRadius={1}
                            canvasWidth={1200}
                            canvasHeight={200}
                            hideInterface={true}
                            hideGrid={true}
                            ref={canvasRef}
                          />
                        </Box>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            marginTop: 5,
                          }}
                        >
                          <Button
                            variant="contained"
                            onClick={handleExport}
                            sx={{
                              backgroundColor: "#303030",
                              ":hover": {
                                bgcolor: "#5c5c5c",
                              },
                              marginRight: 2,
                            }}
                          >
                            Salvar Assinatura
                          </Button>
                          <Button
                            variant="contained"
                            onClick={() => {
                              canvasRef.current.clear();
                            }}
                            sx={{
                              backgroundColor: "#FF0000",
                              ":hover": {
                                bgcolor: "#AA0000",
                              },
                            }}
                          >
                            Limpar Assinatura
                          </Button>
                        </Box>
                      </>
                    )}
                  </Box>
                </Modal>
                <Modal open={isCameraOpen}>
                  <Box
                    sx={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      bgcolor: "background.paper",
                      border: "2px solid #000",
                      boxShadow: 24,
                      p: 4,
                      width: "80%",
                      maxWidth: 800,
                      height: "80%",
                      maxHeight: 700,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <IconButton
                      onClick={handleCloseCamera}
                      sx={{
                        position: "absolute",
                        top: 10,
                        right: 10,
                        backgroundColor: "red",
                        color: "white",
                        ":hover": {
                          bgcolor: "#5c5c5c",
                        },
                      }}
                    >
                      <Close />
                    </IconButton>
                    <Webcam
                      audio={false}
                      ref={webcamRef}
                      screenshotFormat="image/png"
                      videoConstraints={videoConstraints}
                      style={{
                        width: "100%",
                        height: "auto",
                        marginBottom: 50,
                      }}
                    />
                    <Grid
                      container
                      spacing={2}
                      sx={{ mt: { xs: -13, sm: -10, md: -6 } }}
                    >
                      <Grid item xs={12} sm={6} md={6}>
                        <Button
                          variant="contained"
                          onClick={capture}
                          sx={{
                            display: "block",
                            width: "100%",
                            maxWidth: "100%",
                            backgroundColor: "#303030",
                            ":hover": {
                              bgcolor: "#5c5c5c",
                            },
                          }}
                        >
                          Capturar Imagem
                        </Button>
                      </Grid>
                      <Grid item xs={12} sm={6} md={6}>
                        <IconButton
                          onClick={toggleCameraFacing}
                          sx={{
                            width: "100%",
                            maxWidth: "100%",
                            backgroundColor: "#303030",
                            color: "white",
                            ":hover": {
                              bgcolor: "#5c5c5c",
                            },
                            borderRadius: 1,
                          }}
                        >
                          {isFrontFacing ? <CameraFront /> : <CameraRear />}
                        </IconButton>
                      </Grid>
                    </Grid>
                  </Box>
                </Modal>
                <Button
                  variant="contained"
                  sx={{
                    width: "100%",
                    backgroundColor: "#303030",
                    marginTop: 2,
                  }}
                  disabled={!selectedCompany || !selectedLocation || !signed}
                  onClick={handleTransferVehicle}
                >
                  Transferir
                </Button>
              </Box>
            )}

            <Typography variant="h6" component="h6" sx={{ mt: 4 }}>
              Histórico de Transferências
            </Typography>

            {historico.length === 0 ? (
              <Typography>
                Não há registros de transferências desse veículo
              </Typography>
            ) : (
              <TableContainer component={Paper} sx={{ mt: 2 }}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Responsável</TableCell>
                      <TableCell>Data</TableCell>
                      <TableCell>Origem</TableCell>
                      <TableCell>Destino</TableCell>
                      <TableCell />
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {historico.map((transferencias, index) => (
                      <React.Fragment key={index}>
                        {transferencias.map(
                          (
                            transferencia: Transferencia,
                            innerIndex: number,
                          ) => (
                            <React.Fragment key={innerIndex}>
                              <TableRow
                                onClick={() => handleRowClick(innerIndex)}
                              >
                                <TableCell>
                                  {transferencia.Responsavel}
                                </TableCell>
                                <TableCell>{transferencia.data}</TableCell>
                                <TableCell>{transferencia.origem}</TableCell>
                                <TableCell>{transferencia.destino}</TableCell>
                                <TableCell>
                                  <IconButton
                                    aria-label="expand row"
                                    size="small"
                                  >
                                    {openRow === innerIndex ? (
                                      <KeyboardArrowUp />
                                    ) : (
                                      <KeyboardArrowDown />
                                    )}
                                  </IconButton>
                                </TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell
                                  style={{ paddingBottom: 0, paddingTop: 0 }}
                                  colSpan={6}
                                >
                                  <Collapse
                                    in={openRow === innerIndex}
                                    timeout="auto"
                                    unmountOnExit
                                  >
                                    <Box
                                      margin={1}
                                      display="flex"
                                      alignItems="center"
                                    >
                                      <Typography
                                        variant="body2"
                                        sx={{ color: "text.secondary" }}
                                        mt={1}
                                        style={{ flex: 1 }}
                                      >
                                        <strong>Observação:</strong>{" "}
                                        <span
                                          style={{
                                            color: "#5f5f5f",
                                            fontSize: "0.9rem",
                                            whiteSpace: "pre-wrap",
                                            maxWidth: "300px",
                                            overflowWrap: "break-word",
                                            display: "block",
                                          }}
                                        >
                                          {
                                            transferencia.observacao_historico_transferencia_veiculo
                                          }
                                        </span>
                                      </Typography>
                                      <Button
                                        sx={{
                                          alignSelf: "start",
                                          alignItems: "start",
                                        }}
                                        onClick={() =>
                                          handleOpenModaHistoricoFotos(
                                            transferencia.fotos,
                                          )
                                        }
                                      >
                                        Ver Fotos
                                        <Photo sx={{ marginLeft: 1 }} />
                                      </Button>
                                    </Box>
                                  </Collapse>
                                </TableCell>
                              </TableRow>
                            </React.Fragment>
                          ),
                        )}
                      </React.Fragment>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </Box>
        </Fade>
      </Modal>
      <Modal
        open={openModal}
        onClose={handleCloseModal}
        closeAfterTransition
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={openModal}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "80%",
              bgcolor: "background.paper",
              boxShadow: 24,
              p: 4,
              borderRadius: 2,
              maxHeight: "80vh",
              overflowY: "auto",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <Typography variant="h5" component="h4">
                Fotos do Veículo
              </Typography>
              <IconButton
                size="medium"
                edge="start"
                aria-label="close"
                sx={{
                  mr: 2,
                  backgroundColor: "red",
                  color: "white",
                  ml: 2,
                  ":hover": {
                    bgcolor: "#5c5c5c",
                  },
                }}
                onClick={handleCloseModal}
              >
                <Close />
              </IconButton>
            </Box>

            {photos ? (
              <>
                {/* Fotos Anexadas */}
                <Typography variant="body1" fontWeight={800} mt={2}>
                  Fotos Anexadas:
                </Typography>
                {photos.anexadas?.length > 0 ? (
                  <Grid container spacing={2} mb={2}>
                    {photos.anexadas.map((photo: string, index: number) => (
                      <Grid item xs={12} sm={6} md={4} key={index}>
                        <Box sx={{ position: "relative" }}>
                          <img
                            src={photo}
                            alt={`Anexada ${index}`}
                            style={{ width: "100%", cursor: "pointer" }}
                            onClick={() => handleOpenFullscreen(photo)}
                          />
                          <Button
                            variant="contained"
                            sx={{
                              position: "absolute",
                              top: 8,
                              right: 8,
                              bgcolor: "rgba(0, 0, 0, 0.6)",
                              color: "#fff",
                              "&:hover": {
                                bgcolor: "rgba(0, 0, 0, 0.8)",
                              },
                            }}
                            onClick={() => handleDownloadImage(photo)}
                          >
                            <Download />
                          </Button>
                        </Box>
                      </Grid>
                    ))}
                  </Grid>
                ) : (
                  <Typography>Não possui fotos anexadas</Typography>
                )}

                {/* Código Rádio */}
                <Typography variant="body1" fontWeight={800} mt={2}>
                  Código Rádio:
                </Typography>
                {photos.codigo_radio.length > 0 ? (
                  <Grid container spacing={2} mb={2}>
                    {photos.codigo_radio.map((photo: string, index: number) => (
                      <Grid item xs={12} sm={6} md={4} key={index}>
                        <Box sx={{ position: "relative" }}>
                          <img
                            src={`${photo}`}
                            alt={`Código Rádio ${index}`}
                            style={{ width: "100%" }}
                          />
                          <Button
                            variant="contained"
                            sx={{
                              position: "absolute",
                              top: 8,
                              right: 8,
                              bgcolor: "rgba(0, 0, 0, 0.6)",
                              color: "#fff",
                              "&:hover": {
                                bgcolor: "rgba(0, 0, 0, 0.8)",
                              },
                            }}
                            onClick={() => handleDownloadImage(`${photo}`)}
                          >
                            <Download />
                          </Button>
                        </Box>
                      </Grid>
                    ))}
                  </Grid>
                ) : (
                  <Typography>Não possui fotos de Código de Rádio</Typography>
                )}

                {/* KM */}
                <Typography variant="body1" fontWeight={800} mt={2}>
                  KM:
                </Typography>
                {photos.km.length > 0 ? (
                  <Grid container spacing={2} mb={2}>
                    {photos.km.map((photo: any, index: number) => (
                      <Grid item xs={12} sm={6} md={4} key={index}>
                        <Box sx={{ position: "relative" }}>
                          <img
                            src={`${photo.imagem_km_foto}`}
                            alt={`KM ${index}`}
                            style={{ width: "100%" }}
                          />
                          <Button
                            variant="contained"
                            sx={{
                              position: "absolute",
                              top: 8,
                              right: 8,
                              bgcolor: "rgba(0, 0, 0, 0.6)",
                              color: "#fff",
                              "&:hover": {
                                bgcolor: "rgba(0, 0, 0, 0.8)",
                              },
                            }}
                            onClick={() =>
                              handleDownloadImage(`${photo.imagem_km_foto}`)
                            }
                          >
                            <Download />
                          </Button>
                        </Box>
                      </Grid>
                    ))}
                  </Grid>
                ) : (
                  <Typography>Não possui fotos de KM</Typography>
                )}

                {/* Transferência */}
                <Typography variant="body1" fontWeight={800} mt={2}>
                  Fotos Transferência:
                </Typography>
                {photos.transferencia.length > 0 ? (
                  <Grid container spacing={2} mb={2}>
                    {photos.transferencia.map(
                      (photo: string, index: number) => (
                        <Grid item xs={12} sm={6} md={4} key={index}>
                          <Box sx={{ position: "relative" }}>
                            <img
                              src={`${photo}`}
                              alt={`Transferência ${index}`}
                              style={{ width: "100%" }}
                            />
                            <Button
                              variant="contained"
                              sx={{
                                position: "absolute",
                                top: 8,
                                right: 8,
                                bgcolor: "rgba(0, 0, 0, 0.6)",
                                color: "#fff",
                                "&:hover": {
                                  bgcolor: "rgba(0, 0, 0, 0.8)",
                                },
                              }}
                              onClick={() => handleDownloadImage(`${photo}`)}
                            >
                              <Download />
                            </Button>
                          </Box>
                        </Grid>
                      ),
                    )}
                  </Grid>
                ) : (
                  <Typography>Não possui fotos de transferência</Typography>
                )}

                {/* Checklist */}
                {Object.keys(photos.checklist).map((checklistKey) => (
                  <React.Fragment key={checklistKey}>
                    <Typography variant="h6" fontWeight={800} mt={4} mb={2}>
                      {checklistKey}
                    </Typography>

                    {photos.checklist[checklistKey].length > 0 ? (
                      <Grid container spacing={3}>
                        {photos.checklist[checklistKey].map(
                          (item: string | string[], index: number) => {
                            const isQuestionPhoto = Array.isArray(item);
                            const [photo, questionName] = isQuestionPhoto
                              ? item
                              : [item, null];
                            const imageUrl = `${photo}`;

                            return (
                              <Grid item xs={12} sm={6} md={4} key={index}>
                                <Card sx={{ position: "relative" }}>
                                  <CardMedia
                                    component="img"
                                    image={imageUrl}
                                    alt={
                                      questionName || `${checklistKey} ${index}`
                                    }
                                    sx={{ height: 200, objectFit: "cover" }}
                                    onClick={() =>
                                      handleOpenFullscreen(imageUrl)
                                    }
                                  />
                                  <CardContent>
                                    {questionName ? (
                                      <Chip
                                        label={`Pergunta: ${questionName}`}
                                        icon={<HelpOutline />}
                                        sx={{ mb: 1 }}
                                        color="info"
                                      />
                                    ) : (
                                      <Chip
                                        label="Imagem geral do checklist"
                                        sx={{ mb: 1 }}
                                        color="default"
                                      />
                                    )}
                                    <Button
                                      variant="outlined"
                                      fullWidth
                                      onClick={() =>
                                        handleDownloadImage(imageUrl)
                                      }
                                    >
                                      <Download sx={{ mr: 1 }} />
                                      Baixar imagem
                                    </Button>
                                  </CardContent>
                                </Card>
                              </Grid>
                            );
                          },
                        )}
                      </Grid>
                    ) : (
                      <Typography>
                        Não possui fotos de {checklistKey}
                      </Typography>
                    )}
                  </React.Fragment>
                ))}
              </>
            ) : (
              <Typography>Carregando fotos...</Typography>
            )}
          </Box>
        </Fade>
      </Modal>
      <Modal
        open={isFullscreenOpen}
        onClose={handleCloseFullscreen}
        closeAfterTransition
        BackdropProps={{ timeout: 500 }}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Fade in={isFullscreenOpen}>
          <Box
            sx={{
              position: "relative",
              width: "100vw",
              height: "100vh",
              bgcolor: "rgba(0,0,0,0.9)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              p: 2,
            }}
          >
            <IconButton
              onClick={handleCloseFullscreen}
              sx={{
                position: "absolute",
                top: 16,
                right: 16,
                bgcolor: "rgb(255, 0, 0)",
                color: "white",
                zIndex: 10,
                "&:hover": {
                  bgcolor: "rgba(255,255,255,0.4)",
                },
              }}
            >
              <Close />
            </IconButton>

            <img
              src={selectedImage ?? ""}
              alt="Imagem em tela cheia"
              style={{
                maxWidth: "100%",
                maxHeight: "100%",
                width: "auto",
                height: "auto",
                objectFit: "contain",
                borderRadius: 8,
              }}
            />
          </Box>
        </Fade>
      </Modal>

      <Modal
        open={openModalHistoricoFotos}
        onClose={handleCloseModalHistoricoFotos}
        closeAfterTransition
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={openModalHistoricoFotos}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "80%",
              bgcolor: "background.paper",
              boxShadow: 24,
              p: 4,
              borderRadius: 2,
              maxHeight: "80vh",
              overflowY: "auto",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <Typography variant="h5" component="h4">
                Fotos da Transferência do Veículo
              </Typography>
              <IconButton
                size="medium"
                edge="start"
                aria-label="close"
                sx={{
                  mr: 2,
                  backgroundColor: "red",
                  color: "white",
                  ml: 2,
                  ":hover": {
                    bgcolor: "#5c5c5c",
                  },
                }}
                onClick={handleCloseModalHistoricoFotos}
              >
                <Close />
              </IconButton>
            </Box>
            <Grid container spacing={2}>
              {historicoFotos.length === 0 ? (
                <Typography
                  variant="body1"
                  color="textSecondary"
                  mt={2}
                  textAlign={"center"}
                  ml={2}
                >
                  Não há fotos para esta transferência.
                </Typography>
              ) : (
                historicoFotos.map((foto, index) => (
                  <Grid item xs={12} sm={6} md={4} key={index}>
                    <img
                      src={`${process.env.REACT_APP_API_DOMAIN}/storage/${foto}`}
                      alt={`Transferência ${index}`}
                      style={{
                        width: "100%",
                        height: "auto",
                        borderRadius: "8px",
                      }}
                    />
                  </Grid>
                ))
              )}
            </Grid>
          </Box>
        </Fade>
      </Modal>

      <EntregaCameraModal
        open={cameraEntregaOpen}
        onClose={() => setCameraEntregaOpen(false)}
        onConfirm={handleSalvarFotosEntrega}
        loading={loadingEnvioFotos}
      />
    </Grid>
  );
};

export default VehicleCard;
